import type { ButtonProps as AntdButtonProps } from 'antd'
import { Button as AntdButton } from 'antd'

import { createHeapDataAttribute } from '@/heap/createHeapDataAttribute'
import { DefaultHeapAttributes, type HeapAttributesType } from '@/heap/heapAttributes'
import { forwardRef } from 'react'
import styles from './styles.module.scss'

export interface ButtonProps extends AntdButtonProps {
  alignWithoutPadding?: true
  dataAttribute?: HeapAttributesType
}

export const Button = forwardRef<HTMLButtonElement, ButtonProps>(
  (
    { className, alignWithoutPadding, dataAttribute = DefaultHeapAttributes.button, ...props },
    ref,
  ) => {
    const customClassnames = [styles.alignWithoutPadding, className].join(' ')

    return (
      <AntdButton
        {...props}
        className={alignWithoutPadding ? customClassnames : className}
        ref={ref}
        {...createHeapDataAttribute(dataAttribute)}
      />
    )
  },
)
Button.displayName = 'Button'
